var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-box"},[_c('div',{staticClass:"error-box"},[_c('img',{attrs:{"src":_vm.imgSrc}}),_c('br'),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" 您的微信暂无绑定宣教信息"),_c('br'),_vm._v("请至公众号绑定 ")])
}]

export { render, staticRenderFns }